export default class MatchMedia {
    static small() {
        return window.matchMedia('(max-width: 991px)').matches;
    }

    static notSmall() {
        return window.matchMedia('(min-width: 992px)').matches;
    }
}
